export default __webpack_public_path__ + "static/media/button.92e81186.gif";